<template>

<div >



        <div class="sticky-header">
        <navbar :sportswithodds="$store.state.sports" v-if="$store.state.langfileloaded"></navbar>
        

        <div v-if="$mq === 'sm' || $mq === 'md' ">

            <menuitems  :templatetype="1" v-if="$store.state.langfileloaded" ></menuitems> 
        </div>
        <div v-else>

            <features type="across" v-if="$store.state.langfileloaded"></features>
        </div>
        </div>


            <div class="grid-x align-center" >

                <div id="leftside" class="cell xxlarge-2 show-for-xxlarge" style="background-color:  #ECEEF3">
                    <template v-if="$mq === 'lg' && !$store.state.wasSSR">
                        <bannerad :bannertype="colorandBannerHTML(2)" :key="1"  actualbanbackcolour="#ECEEF3" bannerdivheight="100%" v-if="colorandBannerHTML(2) != ''"></bannerad>
                    </template>
                </div>

                <div></div>

                <div class="cell large-12 xlarge-10 xxlarge-8">
                <template v-if="!$store.state.wasSSR">
                    <popup></popup>
                    <vue-confirm-dialog></vue-confirm-dialog>
                </template>

             

                    <div class="grid-x" >

                       <div id="dropdownmenu" class="cell shrink" v-if="$mq === 'lg'">

                        <menuitems cn="vertical menu icons icons-left"  :templatetype="0" v-if="$store.state.langfileloaded"> </menuitems>

                        </div>


                       <div class="cell auto" style="min-height:100vh">

                       <template v-if="$store.state.langfileloaded">

                            <router-view ></router-view>
                        </template>
                        </div>
                    </div>

                </div>

                <div id="rightside" class="cell xlarge-2"   v-if="$mq === 'lg' && !$store.state.wasSSR" style="background-color: #ECEEF3">
                    <bannerad :bannertype="colorandBannerHTML(2)" :key="2"  actualbanbackcolour="#ECEEF3" bannerdivheight="100%"  v-if="colorandBannerHTML(2) != ''"></bannerad>
                </div>

           </div>

          <div class="cell" style="background-color:rgb(226,227,229);border-top:1px solid darkslategray">
            <ul style="list-style-type: none;padding:30px;text-align: center;font-size:1rem">
              <li style="padding:20px">
                    <a href="#" ><img   width="172px" height="24px" :src="require('/public/assets/images/OddsGaloreLogoGrey.png')" alt="Oddsgalore Logo"/></a>

                </li>
                <li>
                    <router-link @click.native="scrollToTop" :to="{ name: 'kitviewer' }" class="qgreylink">{{ langConv('Kit Sizes') }}</router-link>
                </li>
                <li>
                    <router-link @click.native="scrollToTop" :to="{ name: 'feedback' }" class="qgreylink">{{ langConv('Contact us') }}</router-link>
                </li>
                <template v-if="$store.state.signedin && ($store.state.email == 'siobhan.trotman@hotmail.com' || $store.state.email == 'harvey.trotman@gmail.com')">
                    <li>
                        <router-link @click.native="scrollToTop" :to="{ name: 'hutchdutchbetsettlement' }" class="qgreylink" ><span>Bet Settlement</span></router-link>
                    </li>
                </template>
                <li>
                    <router-link @click.native="scrollToTop" nk :to="{ name: 'termsandconditions' }" class="qgreylink">{{ langConv('Terms and conditions') }}</router-link>
                </li>
                <li>
                    <router-link @click.native="scrollToTop" :to="{ name: 'cookiepolicy' }" class="qgreylink">{{ langConv('Cookie Policy') }}</router-link>
                </li>
                <li>
                    <router-link @click.native="scrollToTop" :to="{ name: 'privacypolicy' }" class="qgreylink">{{ langConv('Privacy Policy') }}</router-link>
                </li>
                <li>
                    <div class="qgreylink" >{{ langConv('Reset site settings to defaults') }}</div>
                </li>
                <li style="height:40px">
                        <div style="padding-top:5px;margin:auto;width:160px"><begambleaware/></div>
                </li>
                <li>
                    <div>{{ langConv('Please Gamble responsibly') }}</div>
                </li>
                <li>
                     <span class="qlighttext">{{ $store.state.ipaddress  }} - {{ $store.state.countryname }}</span>
                </li>

            </ul>

        </div>

            <!-- <div class="cell show-for-small-only footer" style="z-index:99999">
                <bannerad :bannertype="colorandBannerHTML(5)" :key="3" v-if="advertsloaded" v-if="colorandBannerHTML(5) != ''"></bannerad>
            </div> -->

<!-- only load cookie if dataloaded-->
<div  data-nosnippet>
  <cookiespolicy
  :debug="false"
  :disableDecline="true"
  :showPostponeButton="false"
  @clicked-accept="cookieClickedAccept"
  @clicked-decline="cookieClickedDecline"
  @clicked-postpone="cookieClickedPostpone"
  @removed-cookie="cookieRemovedCookie"
  @status="cookieStatus"
  elementId="myPanel1"
  position="bottom"
  ref="myPanel1"
  transitionName="slideFromBottom"
  type="bar"
> 

<template #message>
    {{langConv("We use cookies to ensure you get the best experience on our website. The only 3rd party cookies are those of advertising banners used on the site")}}.
    <a href="https://oddsgalore.com/cookie-policy" target="_blank">{{langConv('Learn More...')}}</a>
  </template>

</cookiespolicy> -
</div>


</div>

</template>

<script>

 const bannerad = () => import('./components/adverts/bannerad.vue');
 import menuitems from './components/components/menuitems.vue';
 import navbar from './components/navigation/navbar.vue';

 const popup = () => import('./components/components/popup.vue');
 import features from './components/components/features.vue'
 import begambleaware from './components/adverts/begambleaware.vue'
import cookiespolicy  from 'vue-cookie-accept-decline';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';





export default {
    name: "App",
    data: function data() {
                return {
                    infotabledata: null,
                    // default odds analysis table value
                    advertsloaded: false,
                    adbanners: [],
                    bannertypes: [1, 2, 6, 5],
                    sportsloaded: false,
                    teamname: '',
                    team: ["Stevenage"],
                    graphlegend: '',
                    venue: [],
                    type: 'script'

                }
            },


            components: {

                bannerad: bannerad,
                navbar: navbar,
                menuitems: menuitems,
                popup,
                features,
                begambleaware,
                cookiespolicy

            },

            watch:{
                $route (to, from){

                    
                    if (to.name == 'eventodds') {
                         to.params["tpoid"]= this.$store.state.bid;
                    }
                    if (to.name == 'outrightodds') {
                        to.params["orid"]= this.$store.state.bid;
                    }

                    if (!this.$store.state.wasSSR) {
                    let params = '[{ "Name": "@Type", "Value": "' + to.name + '"}, { "Name": "@Params", "Value": ' + JSON.stringify(to.params) + '},{ "Name": "@Country", "Value": "' + this.$store.state.country + '" },{ "Name": "@IPAddress", "Value": "' + this.$store.state.ipaddress + '"}]';
                    let url = process.env.VUE_APP_WEBAPI  + "SaveRetrieveandDeleteData.svc/SaveGeneric";
                    let spname = "UpdateSiteStatistics";

                    // //get bet results for that bet
                    this.newgenericpost(url, params,spname).then(response => { this.results = response});
                     }
                }

            },

            async asyncData({ app, localLoader, store, route, isServer }) {

                if (isServer) {

                    try {
                    const featuresacross = localLoader('featuresacross.json')
                    store.commit('setFeatures', featuresacross)

                    //all sports with odds
                    const sportswithodds = localLoader("sportswithodds.json")
                    store.commit("setSports", sportswithodds);

                    //favourite competitions currently in db
                    const popularcompetitions = localLoader("popularcompetitions.json")
                    store.commit("setPopComps", popularcompetitions)

                    //available odds analysis types
                    const oddsanalysistypes = localLoader("oddsanalysistypes.json")
                    store.commit("setOatTypes", oddsanalysistypes);

                     //for the time stuff just use server
                     store.commit("setTimediff", new Date().getTimezoneOffset())

                     store.commit("setTzdesc", Intl.DateTimeFormat().resolvedOptions().timeZone)

                     store.commit("setIPAddress", "0.0.0.0")
                
                     //dont worry about session timeouts not important for ssr or IP  configuration - just set as default
                     app.$globals.setDefaultCountrySettings(store);

                     //set bookmakers with licenses for that country
                     app.$globals.setSelectedBookmakerswithCountryLicense(store, localLoader)

                     //adverts
                    const ads = localLoader('slider ' + store.state.countryname + '.json')
                    store.commit("setAds", ads)

          


                    } catch (err) {
                        console.error("asyncData Fail: " + err.message)
                    }

                }
            },

           mounted()  {

              

                if (!this.$store.state.wasSSR) {

                     this.initialdataload();

                     this.appinit();


                    // if (!window.gtag) return;
                    //     requestAnimationFrame(() => {
                    //     window.gtag('event', 'page_view', {
                    //         page_title: document.title,
                    //         page_location: window.location.href,
                    //         page_path: this.$route.fullPath,
                    //     });
                    // });



                     window.__PRERENDER_READY = true;
                }

            },

            methods: {


                async appinit() {

                             //by default hints are off


                            // this.$store.commit("setShowHints", false)

                             //check last session time. if > 3 hours then refresh to standard TODO
                             let currentdate = this.$store.state.sessiontime;

                             var isDate;
                             if (isNaN(Date.parse(currentdate))) {isDate = false} else {isDate = true}

                             let d = new Date();

                             //no date so put in the current one
                             if (isDate == false) { this.$store.commit("setSessionTime", d);}


                             //this.$store.commit("setRightSide", false);



                             //let minuteselapsed = 1;

                             //compare dates
                             if (isDate == true) {
                                let currdateasdate = new Date(currentdate);
                                let lastdate = new Date(currdateasdate.getTime()+86400000); //logout after a day *minuteselapsed);
                                if (d > lastdate) {
                                    this.logOut(this);
                                    this.$store.commit("setSessionTime", d);
                                }
                             }

                               try {
                                
    await this.setIPDependantDefaults();
    
  } catch (err) {
    console.warn("setIPDependantDefaults failed, applying defaults:", err);
    this.setDefaultCountrySettings();
  }
  



                },

                scrollToTop() {

                    if (!this.$store.state.wasSSR) {
                       window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }

                 },

                //show Modal window
                showModal: function (val) {
                    this.$modal.show(val);

                },

                hidePopUp: function (val, reload) {
                    if (reload === undefined) reload = true;

                    this.$modal.hide(val);

                    //update screen (reload for mo?)
                    if (reload === true) location.reload(false);
                },

                changeteam: function () {
                    this.team[0] = this.teamname;
                    this.$forceUpdate();
                },

                // async routerlogic(){


                //     if (!this.$isSSR()) {

                //       this.$router.afterEach((to) => {

                //             var googleid = 'G-XWNJ6LV2PG';
                //             var site = "OddsGalore"
                //             gtag('config', googleid, {page_path: to.fullPath,app_name: site,send_page_view: true,});
                //         });

                // }

                //},

                cookieClickedAccept: function() {},
                cookieClickedDecline: function() {},
                cookieClickedPostpone: function() {},
                cookieRemovedCookie: function() {},
                cookieStatus: function() {}

            }

        };

</script>

<style>
 .sticky-header {
    position: sticky;
    top: 0;
    z-index: 9999;

    background: white;

 }




</style>

<style lang="scss">
@import "./style/sprites.css";
@import "./style/site.css";
@import "./style/bkmmedium.css";

@import './style/_settings'; //own version of the settings file not the one you get in scss directory of foundation
@import '../node_modules/foundation-sites/scss/foundation';


// Global styles

@include foundation-global-styles;
@include foundation-forms;
@include foundation-typography;
//@import '../node_modules/foundation-sites/scss/util/mixins';

// Grids (choose one)
@include foundation-xy-grid-classes;
// @include foundation-grid;
// @include foundation-flex-grid;

// Generic components
@include foundation-button;
@include foundation-button-group;
@include foundation-close-button;
@include foundation-label;
//@include foundation-progress-bar;
//@include foundation-slider;
@include foundation-switch;
@include foundation-table;
// Basic components
@include foundation-badge;
@include foundation-breadcrumbs;
//@include foundation-callout;
//@include foundation-card;
@include foundation-dropdown;
//@include foundation-pagination;//
//@include foundation-tooltip;

// Containers
//@include foundation-accordion;
//@include foundation-media-object;
//@include foundation-orbit;
//@include foundation-responsive-embed;
//@include foundation-tabs;
//@include foundation-thumbnail;
// Menu-based containers
@include foundation-menu;
@include foundation-menu-icon;
//@include foundation-accordion-menu;
//@include foundation-drilldown-menu;
//@include foundation-dropdown-menu;

// Layout components
//@include foundation-off-canvas;
//@include foundation-reveal;
//@include foundation-sticky;
@include foundation-title-bar;
@include foundation-top-bar;

// Helpers
@include foundation-float-classes;
// @include foundation-flex-classes;
@include foundation-visibility-classes;
// @include foundation-prototype-classes;





</style> 